export { FdrStyledTextBlock } from './fdr-styled-text-block';
